export default __webpack_public_path__ + "9480c6af23f202da6921a0b532864377.svg";